import React from 'react';
import { Box, useMediaQuery, useTheme, Typography, Button } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { ComplianceTable } from '../../LegalComplianceControl/CarryLK/List/ComplianceTable';
import { StepButtonBar } from './StepButtonBar';
import { StepProps } from './types';

const PRIMARY = '#c4122f';
const outlinedRedBtn: React.CSSProperties = { fontWeight: 700, borderColor: PRIMARY, color: PRIMARY };

interface DeleteStep2LawsTableProps extends Partial<StepProps> {
  selectedRows: any[];
  setSelectedRows: (rows: any[]) => void;
  selectedRowsData: any[];
  setSelectedRowsData: (data: any[]) => void;
  selectedCompanyUnit: any;
  onNext: (data?: any) => void;
  onBack: () => void;
  onCancel: () => void;
  isFirstStep?: boolean;
}

const DeleteStep2LawsTable = ({
  selectedRows,
  setSelectedRows,
  selectedRowsData,
  setSelectedRowsData,
  selectedCompanyUnit,
  onNext,
  onBack,
  onCancel,
}: DeleteStep2LawsTableProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(2) : theme.spacing(3);

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: '100%',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
          }}
        >
          {selectedCompanyUnit && (
            <>
              <Box style={{ maxHeight: '500px', overflow: 'auto' }}>
                <ComplianceTable
                  selectedRows={selectedRows}
                  type={{value:0,id:0}}
                  setSelectedRows={setSelectedRows}
                  companyUnit={{ label: selectedCompanyUnit?.name, value: selectedCompanyUnit?.id }}
                  showMarkAll
                  selectedRowsData={selectedRowsData}
                  setSelectedRowsData={setSelectedRowsData}
                />
              </Box>
            </>
          )}
        </div>
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={onNext}
          nextLabel="form.next"
          nextDisabled={selectedRows.length === 0}
          formatMessage={formatMessage}
          showBack={true}
        />
      </Box>
    </div>
  );
};

export default DeleteStep2LawsTable;
